

const hasUserRole = (user, roles) => {
    if (user == null || user.role == null)
        return false;
    if (user.is_internal)
        return true;
    return roles.includes(user.role)
}


export default hasUserRole;